const unauthorizedRegularExpression = {};

unauthorizedRegularExpression.claimReview =
    '(\\/action\\/reviewclaim\\/[0-9A-Fa-f\\-]{36}\\/[0-9A-Fa-f\\-]{36})';

export { unauthorizedRegularExpression };
